export const partnersFr = {
  discardTitle: 'Abandonner les modifications non enregistrées ?',
  discardDescription:
    'Vos modifications ne sont pas enregistrées. Continuez à les modifier ou abandonnez-les explicitement.',
  keepEditing: 'Continuer la modification',
  discard: 'Abandonner',

  all: {
    title: 'Tous les contacts',
    subtitle: 'Aperçu complet de tous les partenaires commerciaux et de leurs rôles.',
  },
  customers: {
    title: 'Clients',
    subtitle: 'Comptes clients, conditions et revenus de tous les clients actifs.',
  },
  prospects: {
    title: 'Prospects / leads',
    subtitle: 'Pipeline des ventes du premier contact à la clôture.',
  },
  suppliers: {
    title: 'Fournisseurs',
    subtitle: "Comptes créditeurs, notations et conditions d'achat.",
  },
  searchPlaceholder: 'Rechercher nom, numéro, ville, numéro de TVA, compte…',
  searchLabel: 'Rechercher des partenaires commerciaux',
  columnsMenu: 'Colonnes',
  createTitle: 'Nouveau partenaire commercial',
  editTitle: 'Modifier le partenaire commercial',
  formDescription:
    "Les rôles contrôlent les champs qui apparaissent. Le numéro de partenaire est attribué automatiquement s'il est laissé vide.",
  created: 'Partenaire créé.',
  updated: 'Partenaire enregistré.',
  saveError: "Le partenaire commercial n'a pas pu être enregistré.",
  validationTitle: 'Vérifier les informations',
  validationSummary: 'Vérifiez les informations signalées. Vos saisies ont été conservées.',
  quick: {
    title: 'Création rapide',
    description:
      'Un rôle et un nom suffisent. Les autres informations peuvent être ajoutées plus tard.',
    completeTitle: 'Création complète',
    completeDescription: 'Modifier toutes les données de base et conditions disponibles.',
    showAll: 'Afficher tous les champs',
    showQuick: 'Revenir à la création rapide',
    defaultsUnavailable:
      'Les valeurs par défaut du mandant sont momentanément indisponibles. Des valeurs sûres sont affichées.',
    step1: '1. Client ou entreprise',
    step2: '2. Adresse (facultatif)',
    step3: '3. Contact (facultatif)',
    step4: '4. Facturation et fiscalité (facultatif)',
    completionHint:
      'Vous pourrez compléter la fiche après l’enregistrement. Avant validation, le document affiche les données métier manquantes sous forme de liste.',
  },
  roles: {
    customer: 'Client',
    prospect: 'Perspective',
    supplier: 'Fournisseur',
  },
  actions: {
    create: 'Nouveau partenaire',
    createCustomer: 'Nouveau client',
    createProspect: 'Nouveau prospect',
    createSupplier: 'Nouveau fournisseur',
    export: 'Exporter',
    call: 'Appeler',
    email: 'E-mail',
    logCall: "Journal d'appel",
    createQuote: 'Créer un document',
    convert: 'Convertir en client',
    backToList: "Retour à l'aperçu",
  },
  tabs: {
    master: 'Données de base et adresses',
    sales: 'Revenus et documents',
    purchasing: 'Achats et articles',
    orders: 'Commandes fournisseur',
    insurance: 'Limite de crédit et assurance',
    customFields: 'Champs personnalisés',
    history: 'Histoire',
    telephony: 'Téléphonie et historique',
    whatsapp: 'WhatsApp',
  },
  sections: {
    roles: 'Rôles',
    rolesHint:
      'Un partenaire peut être à la fois client, prospect et fournisseur. Au moins un rôle est requis.',
    masterData: 'Données de base',
    address: 'Adresse',
    tax: 'Fiscalité et identification',
    customerConditions: 'Conditions client',
    prospect: 'Prospect et pipeline',
    supplier: 'Données du fournisseur',
    customFields: 'Champs personnalisés',
    customFieldsHint:
      "Les champs avec un préfixe de groupe (client :, prospect :, fournisseur :) n'apparaissent que pour le rôle correspondant.",
  },
  detail: {
    since: 'Créé le {{date}}',
  },
  values: {
    days_one: '{{count}} jour',
    days_other: '{{count}} jours',
  },
  columns: {
    partnerNumber: 'Numéro',
    displayName: 'Nom',
    roles: 'Rôles',
    status: 'Statut',
    industry: 'Industrie',
    industryCode: 'Code de secteur',
    email: 'E-mail',
    phone: 'Téléphone',
    city: 'Ville',
    countryCode: 'Pays',
    tags: 'Balises',
    debtorAccountNumber: 'Débiteur',
    paymentTermsDays: 'Conditions de paiement',
    creditLimit: 'Limite de crédit',
    leadStatus: 'Scène',
    leadSource: 'Origine',
    leadScore: 'Note',
    dealSizeEstimated: 'Potentiel',
    winProbability: 'Probabilité',
    expectedClosingDate: 'Clôture attendue',
    creditorAccountNumber: 'Créancier',
    supplierRating: 'Note',
    minimumOrderValue: 'Valeur minimale de commande',
    deliveryTimeDays: 'Délai',
    riskStatus: 'Risque',
  },
  fields: {
    type: 'Type de partenaire',
    status: 'Statut',
    partnerNumber: 'Numéro de partenaire',
    partnerNumberHint: 'Laisser vide pour une affectation automatique (KD-, INT-, LF-).',
    industry: 'Industrie',
    industryCode: 'Code de secteur',
    industryCodeHint:
      'Facultatif : WZ 2025 pour l’Allemagne, NAF/APE pour la France. Recherchez un code ou un libellé officiel ; la sélection renseigne automatiquement le secteur.',
    industryCodeSearchHint:
      '{{count}} codes disponibles. Saisissez un code ou un terme pour affiner la sélection.',
    industryCodeInvalid: 'Saisissez un texte de {{max}} caractères maximum.',
    companyName: "Nom de l'entreprise",
    tradingName: 'Nom commercial',
    legalForm: 'Forme juridique',
    department: 'Département',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    email: 'E-mail',
    phone: 'Téléphone',
    mobile: 'Mobile',
    website: 'Site Web',
    street: 'Rue',
    houseNumber: 'Numéro de maison',
    addressLine2: "Ligne d'adresse 2",
    postalCode: 'Code postal',
    city: 'Ville',
    region: 'Région',
    countryCode: 'Pays',
    vatId: 'Numéro de TVA',
    vatIdStatus: 'Statut du numéro de TVA',
    taxNumber: 'Numéro fiscal',
    siren: 'SIREN',
    siret: 'SIRET',
    taxCategory: 'Stratégie de taxe de vente',
    gln: 'GLN',
    eoriNumber: 'Numéro EORI',
    preferredLanguage: 'Langue préférée des documents',
    preferredLanguageHint:
      'Utilisée pour les nouveaux documents, le portail et les e-mails destinés au client.',
    currency: 'Devise',
    ownerName: 'Gestionnaire de compte',
    tags: 'Balises',
    tagsHint: 'Séparez les valeurs multiples par des virgules.',
    debtorAccountNumber: 'Compte débiteur DATEV',
    debtorAccountHint: 'Plage valide : 10 000 à 69 999.',
    creditLimit: 'Limite de crédit',
    creditRating: 'Cote de crédit',
    creditRatingHint: "Échelle Creditreform 100-600 ; plus bas c'est mieux.",
    priceGroup: 'Groupe de prix',
    defaultDiscountPct: 'Remise',
    paymentTerms: 'Conditions de paiement',
    paymentTermsDays: 'Conditions de paiement (jours)',
    discountPercent: 'Escompte',
    discountDays: "Période d'escompte (jours)",
    deliveryTerms: 'Conditions de livraison',
    minRemainingShelfLifeDays: 'Durée de conservation minimale restante (jours)',
    deliveryBlock: 'Blocage de livraison',
    dunningBlock: 'Blocage de relance',
    leadStatus: 'Étape du pipeline',
    leadSource: 'Origine',
    leadScore: 'Score du prospect (0–100)',
    dealSizeEstimated: 'Taille estimée de la transaction',
    winProbability: 'Probabilité de gagner (%)',
    expectedClosingDate: 'Date de clôture prévue',
    lostReason: 'Raison de la perte',
    convertedAt: 'Converti le',
    creditorAccountNumber: 'Compte créancier DATEV',
    creditorAccountHint: 'Plage valide : 70 000 à 99 999.',
    supplierRating: 'Évaluation du fournisseur',
    minimumOrderValue: 'Valeur minimale de commande',
    deliveryTimeDays: 'Délai standard (jours)',
    incoterms: 'Incoterms',
    supplierIban: 'IBAN',
    supplierBic: 'BIC',
    supplierBankName: 'Banque',
  },
  types: {
    COMPANY: 'Société',
    PERSON: 'Individuel',
  },
  statuses: {
    ACTIVE: 'Actif',
    PROSPECT: 'Perspective',
    BLOCKED: 'Bloqué',
    INACTIVE: 'Inactif',
  },
  vatIdStatuses: {
    UNCHECKED: 'Décoché',
    VALID: 'Valide',
    INVALID: 'Invalide',
    NOT_CHECKABLE: 'Non vérifiable',
    SERVICE_UNAVAILABLE: 'Service indisponible',
  },
  taxCategories: {
    DOMESTIC: 'Régulier (national)',
    EU_B2B: 'Intracommunautaire (UE B2B)',
    EU_B2C: 'B2C UE',
    THIRD_COUNTRY: 'Exportation (pays tiers)',
    REVERSE_CHARGE_DOMESTIC: 'Charge au preneur (national)',
    TAX_EXEMPT: "Exonéré d'impôt",
  },
  industries: {
    RETAIL: 'Commerce de détail',
    WHOLESALE: 'Vente en gros',
    MANUFACTURING: 'Fabrication',
    GASTRONOMY: 'Gastronomie',
    LOGISTICS: 'Logistique',
    HEALTHCARE: 'Santé',
    PUBLIC_SECTOR: 'Secteur public',
    CONSTRUCTION: 'Construction',
    AGRICULTURE: 'Agriculture',
    SERVICES: 'Prestations',
    OTHER: 'Autre',
  },
  leadStatuses: {
    NEW: 'Nouveau',
    CONTACTED: 'Contacté',
    QUALIFIED: 'Qualifié',
    PROPOSAL_SENT: 'Proposition envoyée',
    NEGOTIATION: 'Négociation',
    WON: 'Gagné',
    LOST: 'Perdu',
  },
  leadSources: {
    WEBSITE: 'Site Web',
    TRADE_FAIR: 'Salon',
    REFERRAL: 'Référence',
    COLD_OUTREACH: 'Sensibilisation à froid',
    INBOUND_CALL: 'Appel entrant',
    OTHER: 'Autre',
  },
  supplierRatings: {
    A: 'A – très fiable',
    B: 'B – acceptable',
    C: 'C – critique',
  },
  riskStatuses: {
    NORMAL: 'Rien de remarquable',
    WATCHLIST: 'Liste de surveillance',
    DELIVERY_LOCK: 'Verrouillage de livraison',
    SALES_LOCK: 'Verrouillage des ventes',
    COLLECTION: 'Recouvrement de créances / verrouillé',
    INSOLVENCY: 'Insolvabilité',
  },
  risk: {
    lockAction: 'Verrouiller le client',
    unlockAction: 'Déverrouiller le client',
    lockTitle: 'Verrouiller le partenaire commercial',
    lockDescription:
      "Le verrou bloque immédiatement tout document pour {{name}}. La raison est enregistrée dans le journal d'audit.",
    lockConfirm: 'Appliquer le verrouillage',
    lockSuccess: 'Le partenaire est verrouillé.',
    lockError: "Le verrouillage n'a pas pu être appliqué.",
    unlockTitle: 'Libérer le verrouillage',
    unlockDescription: 'Le verrou sur {{name}} sera libéré. Raison précédente : {{reason}}',
    unlockConfirm: 'Libérer le verrouillage',
    unlockSuccess: 'Le verrou a été libéré.',
    unlockError: "Le verrou n'a pas pu être libéré.",
    reasonRequired: 'Une raison est requise.',
    fields: {
      riskStatus: 'Classification des risques',
      followUpStatus: 'Classement après la libération',
      blockReason: 'Raison du blocage',
      blockReasonHint:
        "Exemple : « Numéro de dossier du tribunal d'insolvabilité : IN 412/26 » ou « Remis à l'encaissement Creditreform le 15/08/2026 ».",
      unblockReason: 'Raison de la libération',
      unblockReasonHint: 'Exemple : « Créance réglée en totalité au 01/09/2026 ».',
    },
    banner: {
      blockedTitle: '🚨 ATTENTION : LE CLIENT EST VERROUILLÉ (statut : {{status}})',
      warningTitle: 'Classification des risques : {{status}}',
      reason: 'Raison : {{reason}}',
      since: 'Verrouillé sur {{date}} par {{user}}',
      consequence:
        "Aucune livraison ou facture d'acompte ne peut être créée - libération uniquement contre paiement anticipé ou en espèces.",
    },
  },
  insurance: {
    policySection: "Police d'assurance",
    claimSection: 'Réclamation',
    saved: "L'assurance-crédit commercial a été sauvée.",
    saveError: "L'assurance-crédit commercial n'a pas pu être sauvée.",
    limitExceededHint:
      'La limite maximale assurée est épuisée. Les livraisons ultérieures ne sont pas couvertes.',
    claimIdleHint:
      "La section relative aux réclamations devient pertinente une fois que le client passe au recouvrement ou à l'insolvabilité.",
    openAmount: 'Créances ouvertes : {{amount}}',
    expectedPayout: "Indemnité d'assurance attendue",
    expectedPayoutHint: 'Montant de la réclamation moins la franchise de {{percent}}.',
    actions: {
      prepareClaim: 'Réclamation de dossier',
    },
    statuses: {
      NOT_INSURED: 'Non assuré',
      INSURED: 'Assuré',
      LIMIT_EXCEEDED: 'Limite dépassée',
      CLAIM_REPORTED: 'Réclamation signalée',
      INDEMNIFIED: 'Indemnisé',
    },
    fields: {
      status: "Statut d'assurance",
      company: "Compagnie d'assurance",
      companyHint: 'Exemple : Allianz Trade / Euler Hermes, Atradius, Coface.',
      policyNumber: 'Numéro de politique/limite',
      limit: 'Plafond maximum assuré (€)',
      deductiblePercent: 'Franchise (%)',
      deductibleHint: 'Part que le locataire porte en cas de sinistre.',
      claimDate: 'Date du rapport de réclamation',
      claimAmount: 'Montant de la réclamation déclaré (€)',
      payoutAmount: 'Montant indemnisé (€)',
    },
  },
  incoterms: {
    EXW: 'Départ usine',
    FCA: 'Transporteur gratuit',
    FAS: 'Gratuit à bord du navire',
    FOB: 'Gratuit à bord',
    CFR: 'Coût et fret',
    CIF: 'Coût, assurance et fret',
    CPT: "Port payé jusqu'à",
    CIP: 'Transport et assurance payés à',
    DAP: 'Livré sur place',
    DPU: 'Livré sur place déchargé',
    DDP: 'Rendu droits acquittés',
  },
  documentTypes: {
    QUOTE: 'Devis',
    ORDER: 'Commande',
    DELIVERY_NOTE: 'Bon de livraison',
    INVOICE: 'Facture',
    CREDIT_NOTE: 'Avoir',
    CANCELLATION: 'Annulation',
    PURCHASE_ORDER: 'Bon de commande',
  },
  documentStatuses: {
    DRAFT: 'Brouillon',
    SENT: 'Envoyé',
    ACCEPTED: 'Accepté',
    REJECTED: 'Rejeté',
    CONFIRMED: 'Confirmé',
    IN_PROGRESS: 'En cours',
    PARTIALLY_PROCESSED: 'Partiellement traité',
    SHIPPED: 'Expédié',
    COMPLETED: 'Terminé',
    POSTED: 'Comptabilisé',
    CANCELLED: 'Annulé',
  },
  filters: {
    status: 'Statut',
    industry: 'Industrie',
    industryCode: 'Filtrer le code de secteur (exact)',
    tags: 'Balises',
    vatIdStatus: 'Numéro de TVA',
    riskStatus: 'Risque',
    leadStatus: 'Étape du pipeline',
    leadSource: 'Origine',
    supplierRating: 'Note',
    reset: 'Réinitialiser les filtres',
  },
  states: {
    empty: "Aucun partenaire commercial pour l'instant.",
    emptyFiltered: 'Aucun partenaire commercial ne correspond à la sélection actuelle.',
    error: "La liste n'a pas pu être chargée.",
    detailError: "Le partenaire commercial n'a pas pu être chargé.",
  },
  export: {
    csv: 'Télécharger le fichier CSV',
    xlsx: 'Télécharger Excel',
    success: 'Exportation créée.',
    error: "L'exportation a échoué.",
  },
  bulkDelete: {
    selected: 'Sélectionnés : {{count}}',
    action: 'Supprimer la sélection',
    help: 'Aide à la suppression de plusieurs prospects',
    deleted: 'Supprimés : {{count}}.',
    failed: 'Non supprimés : {{count}}. Ces entrées restent sélectionnées.',
    hasDocuments: 'Ce partenaire possède des documents et ne peut pas être supprimé.',
    error: 'L’entrée n’a pas pu être supprimée.',
    title: 'Supprimer les prospects sélectionnés',
    description:
      'Les prospects sélectionnés seront désactivés et masqués. Les partenaires possédant des documents sont conservés. La suppression concerne l’ensemble du partenaire, y compris ses autres rôles.',
    select: 'Sélectionner {{name}}',
    selectPage: 'Tout sélectionner sur cette page',
  },
  delete: {
    title: 'Supprimer le partenaire',
    description: 'Le partenaire "{{name}}" sera défini comme inactif et masqué.',
    success: 'Partenaire commercial supprimé.',
    error: "Le partenaire commercial n'a pas pu être supprimé.",
  },
  pipeline: {
    title: 'Pipeline des ventes',
    viewSwitch: 'Changer de vue',
    listView: 'Liste',
    boardView: 'Conseil',
    emptyColumn: 'Aucune entrée',
    moved: '{{name}} déplacé vers "{{stage}}".',
    moveError: "L'étape du pipeline n'a pas pu être modifiée.",
    movePrevious: "Reculer le {{name}} d'un étage",
    moveNext: "Avancer le {{name}} d'un étage",
    lostTitle: 'Marquer le prospect comme perdu',
    lostDescription: 'Veuillez indiquer la raison de la perte.',
    lostPlaceholder: 'par ex. prix trop élevé, concurrent choisi, projet reporté',
  },
  convert: {
    title: 'Convertir un prospect en client',
    description:
      'L\'enregistrement "{{name}}" est conservé ; les appels, les notes, les devis et les discussions sont reportés.',
    debtorHint: 'Laisser vide pour attribuer le prochain numéro de débiteur DATEV libre.',
    debtorPlaceholder: 'automatique',
    keepProspectRole: 'Conserver également le rôle de « prospect »',
    success: 'Conversion terminée. Compte débiteur {{number}}.',
    error: 'La conversion a échoué.',
  },
  sales: {
    title: 'Revenus et comportement de paiement',
    loadError: "Les métriques n'ont pas pu être chargées.",
    revenueYtd: "Revenus de l'année à ce jour",
    revenuePreviousYear: "Revenus de l'année précédente",
    revenueChange: 'Évolution annuelle',
    orderIntake: 'Entrées de commandes',
    documentCounts: 'Devis / commandes / livraisons / factures',
    averageOrderValue: 'Valeur moyenne des commandes',
    paidAmount: 'Montant payé',
    credits: 'Avoirs et annulations',
    lastDocuments: 'Dernière commande / facture',
    period: 'Période',
    periods: {
      currentYear: 'Année en cours',
      previousYear: 'Année précédente',
      last12Months: '12 derniers mois',
      all: 'Toute la période',
      custom: 'Période libre',
    },
    from: 'Du',
    to: 'Au',
    searchDocuments: 'Rechercher un numéro ou une référence …',
    allTypes: 'Tous les types',
    allStatuses: 'Tous les statuts',
    allPayments: 'Tous les statuts de paiement',
    noDocumentPermission: "L'autorisation de consulter les documents est requise.",
    columns: {
      number: 'Numéro',
      type: 'Type',
      date: 'Date',
      status: 'Statut',
      payment: 'Paiement',
      net: 'Net',
      gross: 'Brut',
      open: 'Ouvert',
      due: 'Échéance',
      salesRep: 'Commercial',
    },
    revenueTotal: 'Revenus totaux',
    openInvoices_one: 'Facture ouverte ({{count}})',
    openInvoices_other: 'Factures ouvertes ({{count}})',
    overdueInvoices_one: 'Facture en retard ({{count}})',
    overdueInvoices_other: 'Factures en retard ({{count}})',
    openQuotes: 'Cotations ouvertes',
    openOrders: 'Commandes ouvertes',
    averagePaymentTermsDays: 'Moy. conditions de paiement',
    lastOrderDate: 'Dernière commande',
    documents: 'Documents',
    documentsEmpty: "Aucun document pour l'instant.",
    documentsError: "Les documents n'ont pas pu être chargés.",
  },
  supplierProducts: {
    title: "Conditions d'achat",
    subtitle: "Articles, SKU des fournisseurs, prix d'achat et délais de livraison.",
    add: 'Élément de lien',
    createTitle: "Ajouter une condition d'achat",
    editTitle: "Modifier les conditions d'achat",
    description: "Les conditions s'appliquent à ce fournisseur et à l'article sélectionné.",
    product: 'Objet',
    productHint: "Recherche par numéro d'article ou par nom.",
    productPlaceholder: 'Rechercher des éléments…',
    noProducts: 'Aucun élément trouvé.',
    supplierSku: 'SKU du fournisseur',
    purchasePrice: "Prix d'achat (net)",
    packagingUnit: 'Unité de conditionnement',
    packagingFactor: "Unités de base par unité d'emballage",
    leadTimeDays: 'Délai (jours)',
    minOrderQuantity: 'Quantité minimale de commande',
    isPreferredSupplier: 'Fournisseur privilégié pour cet article',
    preferred: 'Préféré',
    notes: 'Remarque',
    empty: "Aucune condition d'achat pour l'instant.",
    saved: "Condition d'achat enregistrée.",
    saveError: "La condition d'achat n'a pas pu être enregistrée.",
    loadError: "Les conditions d'achat n'ont pas pu être chargées.",
    edit: "Modifier les conditions d'achat",
    delete: "Supprimer la condition d'achat",
    deleted: "Condition d'achat supprimée.",
    deleteTitle: "Supprimer la condition d'achat",
    deleteDescription: 'Les conditions pour "{{name}}" seront supprimées.',
    columns: {
      article: 'Objet',
      supplierSku: 'SKU du fournisseur',
      purchasePrice: "Prix d'achat",
      packaging: 'Emballage',
      leadTimeDays: 'Délai',
      minOrderQuantity: 'Min. quantité',
      preferred: 'Préféré',
    },
  },
  supplierOrders: {
    purchaseOrder: 'Bon de commande',
    itemCount_one: 'Ligne {{count}}',
    itemCount_other: 'Lignes {{count}}',
    deliveryDate: 'Entrée de marchandises {{date}}',
    empty: "Aucun bon de commande pour ce fournisseur pour l'instant.",
    loadError: "Les bons de commande n'ont pas pu être chargés.",
  },
  addresses: {
    title: 'Adresses alternatives',
    add: 'Adresse',
    isDefault: 'Par défaut',
    empty: 'Aucune adresse alternative enregistrée.',
    deleted: 'Adresse supprimée.',
    delete: "Supprimer l'adresse",
    deleteTitle: "Supprimer l'adresse",
    deleteDescription: "L'adresse sera supprimée de l'enregistrement du partenaire.",
    loadError: "Les adresses n'ont pas pu être chargées.",
    types: {
      BILLING: 'Adresse de facturation',
      SHIPPING: 'Adresse de livraison',
      OTHER: 'Autre',
    },
  },
  contacts: {
    title: 'Contacts',
    add: 'Contacter',
    isPrimary: 'Contact principal',
    empty: 'Aucun contact enregistré.',
    deleted: 'Contact supprimé.',
    delete: 'Supprimer le contact',
    deleteTitle: 'Supprimer le contact',
    deleteDescription: 'Le contact sera supprimé de la fiche partenaire.',
    loadError: "Les contacts n'ont pas pu être chargés.",
  },
  customFields: {
    title: 'Champs personnalisés dynamiques',
    subtitle: 'Seuls les champs correspondant aux rôles de ce partenaire sont affichés.',
    empty: 'Aucun champ personnalisé défini pour les rôles de ce partenaire.',
    saved: 'Champs personnalisés enregistrés.',
  },
};
